(function () {
	'use strict';

	function init() {
		var form = document.getElementById('productReviewForm');
		if (!form) return;

		var toggleBtn = document.getElementById('productReviewFormToggle');
		var headerLink = document.querySelector('a.product-reviews[href="#productReviewsSection"]');

		function openForm(scroll) {
			form.hidden = false;
			if (toggleBtn) toggleBtn.hidden = true;
			if (scroll) {
				form.scrollIntoView({ behavior: 'smooth', block: 'center' });
			}
			// Fókuszáljunk az első csillagra (jobb UX).
			var firstStar = form.querySelector('.product-review-star-btn');
			if (firstStar) firstStar.focus();
		}

		if (toggleBtn) {
			toggleBtn.addEventListener('click', function () { openForm(false); });
		}
		if (headerLink) {
			headerLink.addEventListener('click', function (e) {
				// Engedjük a natív anchor-görgetést, és utána nyissuk a form-ot.
				setTimeout(function () { openForm(false); }, 350);
			});
		}

		var starBtns = form.querySelectorAll('.product-review-star-btn');
		var ratingInput = document.getElementById('productReviewRating');
		var msg = document.getElementById('productReviewFormMessage');
		var currentRating = 0;

		var messages = {
			ratingRequired: form.dataset.msgRatingRequired || 'Please pick a star rating.',
			reviewThanks: form.dataset.msgReviewThanks || 'Thanks for your review!',
			reviewPending: form.dataset.msgReviewPending || 'Thanks! Your review will appear after moderation.',
			reviewError: form.dataset.msgReviewError || 'Something went wrong. Try again.'
		};

		function paint(value) {
			starBtns.forEach(function (btn, idx) {
				btn.classList.toggle('is-active', (idx + 1) <= value);
			});
		}

		starBtns.forEach(function (btn) {
			btn.addEventListener('mouseenter', function () {
				paint(parseInt(btn.dataset.value, 10));
			});
			btn.addEventListener('mouseleave', function () {
				paint(currentRating);
			});
			btn.addEventListener('click', function () {
				currentRating = parseInt(btn.dataset.value, 10);
				ratingInput.value = currentRating;
				paint(currentRating);
			});
		});

		function showMessage(text, kind) {
			if (!msg) return;
			msg.hidden = false;
			msg.className = 'product-review-form-message mt-3 ' + (kind === 'error' ? 'text-danger' : 'text-success');
			msg.textContent = text;
		}

		form.addEventListener('submit', function (e) {
			e.preventDefault();
			if (!currentRating) {
				showMessage(messages.ratingRequired, 'error');
				return;
			}

			var fd = new FormData(form);
			var token = document.querySelector('meta[name="csrf-token"]');

			fetch('/review/store', {
				method: 'POST',
				headers: {
					'X-Requested-With': 'XMLHttpRequest',
					'X-CSRF-TOKEN': token ? token.getAttribute('content') : (fd.get('_token') || '')
				},
				body: fd,
				credentials: 'same-origin'
			})
				.then(function (r) {
					return r.json().then(function (j) {
						return { ok: r.ok, data: j };
					});
				})
				.then(function (res) {
					if (res.data && res.data.status === 'error' && (res.data.message || '').length) {
						// 401 → bejelentkezés, 429 → rate limit, 422 → trágárság stb.
						if (!res.ok) {
							showMessage(res.data.message, 'error');
							if (/* login required */ res.data && res.data.message && /login|jelentkez/i.test(res.data.message)) {
								setTimeout(function () { window.location.href = '/login'; }, 1500);
							}
							return;
						}
					}
					if (!res.ok) {
						showMessage((res.data && res.data.message) || messages.reviewError, 'error');
						return;
					}
					var moderated = !!(res.data && res.data.moderated);
					showMessage(moderated ? messages.reviewPending : messages.reviewThanks, 'success');
					if (!moderated) {
						// Csak akkor töltsük újra az oldalt, ha a vélemény azonnal megjelenik.
						setTimeout(function () { window.location.reload(); }, 1200);
					}
				})
				.catch(function () {
					showMessage(messages.reviewError, 'error');
				});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
